import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { concepts } from "../../data/framework";
export function InsightSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-243" data-mp="1di1sxvfys8tm">
      <div className="mx-auto max-w-4xl text-center" data-id="element-244" data-mp="1df5u84walg44">
        <SectionHeading dark eyebrow="Here's What Many Professionals Discover" title="Learning About a Bracket System Is Not the Same as Understanding the Entire Treatment Process." data-id="element-245" data-mp="18jgrxtsw1l44" />

        <p className="mt-8 text-base font-semibold text-white/80 sm:text-lg" data-id="element-246" data-mp="fvkx6umvq39z">You can study:</p>
        <ul className="mt-4 flex flex-wrap justify-center gap-2.5" data-id="element-247" data-mp="uk8o2nls5otl">
          {concepts.map(c => <li key={c} className="rounded-full border border-sky/40 bg-navy-800 px-4 py-2 text-sm font-bold text-sky sm:text-base" data-id="element-248" data-mp="pqmljo9bz1bi">
              {c}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-249" data-mp="3t84rtr9gg09t">
          But knowing these concepts separately doesn't automatically explain how they interact.{" "}
          <strong className="text-white" data-id="element-250" data-mp="30dvhyd3xbhe6">The challenge is connecting them within a complete clinical framework.</strong>
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-251" data-mp="357zpaxh3prfs">
          That's the purpose of <span className="font-bold text-gold" data-id="element-252" data-mp="2ch7pzr4qomo8">SELF-LIGATING ORTHODONTICS BLUEPRINT™</span>. It brings
          the essential concepts together in a structured educational collection designed for practical study and case
          review.
        </p>

        <SectionCta dark label="Give Me the Complete Blueprint" data-id="element-253" data-mp="2lgcl0nh3dxvn" />
      </div>
    </section>;
}